/* eslint-disable camelcase */
import React from 'react'
import { formatMoney } from '@shopify/theme-currency'

interface PriceProps {
  product: { total_discount: number, price: number, final_price: number }
}

const PriceDisplay = (props: PriceProps): JSX.Element => {
  const displayFormat = window['theme'].moneyFormat;

  return (
    <p className="product-price">
      {props.product.total_discount > 0 && <s>{formatMoney(props.product.price, displayFormat)}</s>}
      <span>{formatMoney(props.product.final_price, displayFormat)}</span>
    </p>
  )
}


export default PriceDisplay